import React from 'react'
import { connect } from 'react-redux'
import imgData from './logodata'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import CsvDownloader from 'react-csv-downloader';

class FahrerCSVDownload extends React.Component {

	localDateString(einDatum) {
		const d = new Date(einDatum);
		return `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`
	}

	fuehrerscheinValue(f) {
		var res = '';
		if (f === undefined || f.length === 0) {
			return [{fn_id: '-', fn_date: ''}];
		}

		res = f.map((ff,i) => {
			if (!ff.licenseValid) {
				return {fn_id: ff.licenseId, vorname: ff.vorname, nachname: ff.nachname, fn_date: 'Bitte checken!'};
			} else {
				return {fn_id: ff.licenseId, vorname: ff.vorname, nachname: ff.nachname, fn_date: this.localDateString(ff.licenseValidDate)};
			}
		})
		return res;
	}

	csvData() {

		const columns = [
			{
				displayName: "Nummer",
				id: "id"
			},
			{ displayName: "Vorname",
				id: "vorname"
			},
			{ displayName: "Nachname",
				id: "nachname"
			}, {
				displayName: "Email",
				id: "email"
			}, {
				displayName: "Ladegut-Sicherung-Tutorial",
				id: "email_sent"
			}, {
				displayName: "bestanden",
				id: "video_seen"
			}, {
				displayName: "Führerschein",
				id: "fn_id"
			}, {
				displayName: "Führerscheinkontrolle am",
				id: "fuehrerschein"
			}
		];

		const rows = [];
		var i = 0;

		for (var f of this.props.fahrer) {

					const fValue = this.fuehrerscheinValue(f.fuehrerschein);
					i += 1;

					var fn = fValue.shift();
					
					var rObj = {};
					rObj.id = i;
					rObj.vorname = fn.vorname || '-';
					rObj.nachname = fn.nachname || '-';
					rObj.email = f.email;
					rObj.email_sent = f.emailSentDate ? this.localDateString(f.emailSentDate) : "-";
					rObj.video_seen = f.videoSeenDate ? this.localDateString(f.videoSeenDate) : "-";
					rObj.fuehrerschein = fn.fn_date;
					rObj.fn_id = fn.fn_id;
					rows.push(rObj);

					while (fValue.length > 0) {
						fn = fValue.shift();
						rObj = {};
						rObj.id = i;
						rObj.vorname = fn.vorname || '-';
						rObj.nachname = fn.nachname || '-';
						rObj.email = f.email;
						rObj.email_sent = '';
						rObj.video_seen = '';
						rObj.fuehrerschein = fn.fn_date;
						rObj.fn_id = fn.fn_id;
						rows.push(rObj);
					}
				};
		return {columns, rows}
	}

	render() {
		const {columns, rows} = this.csvData();

		const d = new Date();

		const filename = `Fahrer_${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`

		return (
			<div>
				<CsvDownloader
					columns={columns}
					datas={rows}
					filename={filename}
					separator=",">
					<button className="float-right btn btn-default">Download CSV</button>
				</CsvDownloader>
			</div>
		);
	}
}

function mapStateToProps({fahrer}) {
	return { fahrer }
}

//export default FahrerCSVDownload;

export default connect(mapStateToProps)(FahrerCSVDownload);



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerCSVDownload.js